export const issueTriggersBasicInfoInputs = [
    'name',
    'issue',
    'taskTemplate',
  ]